import React, { useEffect, useState } from "react";
import styles from "./sidemodal.module.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import topimage from "../../../public/assets/sidemodalImage.svg";
import InputField from "../../../common/InputFieldWithDropDown/InputField";
import { Col, Modal, Row } from "react-bootstrap";
import borderlesslogo from "../../../public/assets/logo-primary.svg";
import wiselogo from "../../../public/assets/wise.svg";
import redupper from "../../../public/assets/redupper.svg";
import westernunionlogo from "../../../public/assets/westernUnion.svg";
import flywirelogo from "../../../public/assets/flywire.svg";
import hdfc from "../../../public/assets/Major Banks (HDFC, ICICI, Axis etc.).svg";
import { getIbrDetails } from "../../../api";
import { findExchangeRates, inputAmount } from "../../../utils";
import { defaultCurrency } from "../../../constant";

function SideModal(props) {
  const { showModal, setShowModal } = props;
  const [amount, setAmount] = useState("10000");
  const [currency, setCurrency] = useState(defaultCurrency);
  const [calculateddata, setCalculatedData] = useState();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const calculateAmount = async () => {
    try {
      const res = await getIbrDetails(currency);
      setCalculatedData(findExchangeRates(amount, res.rate));
    } catch (error) {}
  };

  useEffect(() => {
    let timeoutId;

    if (amount === "") {
      clearTimeout(timeoutId);
    }

    const generateQuoteWithDebounce = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        if (amount > 0) calculateAmount();
      }, 400);
    };

    generateQuoteWithDebounce();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [amount, currency, showModal]);

  const renderContent = () => (
    <div className={styles.mainDiv}>
      <div className={styles.topimageDiv}>
        <img
          src={topimage}
          alt=""
          style={{ height: "108px", width: "108px" }}
        ></img>
      </div>
      <p className={styles.Heading}>Compare totals after taxes and fees</p>
      <p className={styles.subHeading}>
        Many online providers show you a lower total amount or lower exchange
        rate on their homepage and then add taxes, fees and other markups once
        you've spent a good deal of time setting up your transfer. We, at
        Borderless, believe in showing you all the fees and estimated taxes
        upfront. 
      </p>
      <div className={styles.inputFieldDiv}>
        <InputField
          label={"Recipient gets"}
          conversionValueButton={defaultCurrency}
          value={amount}
          onChange={(e) => {
            inputAmount(e, setAmount);
          }}
          dropdown={true}
          dropdownType={"HomeScreen"}
          setCurrency={setCurrency}
          showJapan={false}
        />
      </div>
      <div className={styles.totalfeesDiv}>
        <div className={styles.totalfeesCol1}>
          Sending {amount !== "" ? amount : "0"} {currency} with
        </div>
        <div className={styles.totalfeesCol2}>
          <p style={{ marginBottom: "0px" }}>You pay</p>
          <p style={{ marginBottom: "0px" }}>
            (Total after fees<span style={{ color: "red" }}>*</span>)
          </p>
        </div>
      </div>
      <div className={styles.comparisonDiv}>
        <Row
          className={styles.companycomparisonDiv}
          style={{ paddingBottom: "32px" }}
        >
          <Col md={6} sm={6} xs={6}>
            <img
              src={borderlesslogo}
              alt="borderless"
              className={styles.logoImage}
            ></img>
          </Col>
          <Col
            md={6}
            sm={6}
            xs={6}
            className={styles.amountDiv}
            style={{ display: "flex", justifyContent: "end" }}
          >
            {calculateddata?.totalamount?.borderless || "--"} INR
          </Col>
        </Row>
        <Row className={styles.companycomparisonDiv}>
          <Col md={6} sm={6} xs={6} className={styles.companyImage}>
            <img src={wiselogo} alt="wise" className={styles.logoImage}></img>
          </Col>
          <Col
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              alignItems: "end",
              flexDirection: "column",
            }}
          >
            <p className={styles.amountDiv} style={{ marginBottom: "0px" }}>
              {calculateddata?.totalamount?.wise || "--"} INR
            </p>
            {calculateddata?.difference?.wise > 0 && (
              <p
                className={styles.amountDivRed}
                style={{ marginBottom: "0px" }}
              >
                <img src={redupper} alt="redupper"></img>{" "}
                {calculateddata?.difference?.wise > 0 ? "-" : ""}{" "}
                {calculateddata?.difference?.wise} INR
              </p>
            )}
          </Col>
        </Row>
        <Row className={styles.companycomparisonDiv}>
          <Col md={6} sm={6} xs={6} className={styles.companyImage}>
            <img
              src={westernunionlogo}
              alt="westernunion"
              className={styles.logoImage}
            ></img>
          </Col>
          <Col
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              alignItems: "end",
              flexDirection: "column",
            }}
          >
            <p className={styles.amountDiv} style={{ marginBottom: "0px" }}>
              {calculateddata?.totalamount?.westernun || "--"} INR
            </p>
            {calculateddata?.difference?.westernun > 0 && (
              <p
                className={styles.amountDivRed}
                style={{ marginBottom: "0px" }}
              >
                <img src={redupper} alt="redupper"></img>{" "}
                {calculateddata?.difference?.westernun > 0 ? "-" : ""}{" "}
                {calculateddata?.difference?.westernun} INR
              </p>
            )}
          </Col>
        </Row>
        <Row className={styles.companycomparisonDiv}>
          <Col md={6} sm={6} xs={6} className={styles.companyImage}>
            <img
              src={flywirelogo}
              alt="flywire"
              className={styles.logoImage}
            ></img>
          </Col>
          <Col
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              alignItems: "end",
              flexDirection: "column",
            }}
          >
            <p className={styles.amountDiv} style={{ marginBottom: "0px" }}>
              {calculateddata?.totalamount?.flywire || "--"} INR
            </p>
            {calculateddata?.difference?.flywire > 0 && (
              <p
                className={styles.amountDivRed}
                style={{ marginBottom: "0px" }}
              >
                <img src={redupper} alt="redupper"></img>{" "}
                {calculateddata?.difference?.flywire > 0 ? "-" : ""}{" "}
                {calculateddata?.difference?.flywire} INR
              </p>
            )}
          </Col>
        </Row>
        <Row
          className={styles.companycomparisonDiv}
          style={{ borderBottom: "none" }}
        >
          <Col md={6} sm={6} xs={6} className={styles.companyImage}>
            <img src={hdfc} alt="hdfc" className={styles.logoImage}></img>
          </Col>
          <Col
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              alignItems: "end",
              flexDirection: "column",
            }}
          >
            <p className={styles.amountDiv} style={{ marginBottom: "0px" }}>
              {calculateddata?.totalamount?.other || "--"} INR
            </p>
            {calculateddata?.difference?.other > 0 && (
              <p
                className={styles.amountDivRed}
                style={{ marginBottom: "0px" }}
              >
                <img src={redupper} alt="redupper"></img>{" "}
                {calculateddata?.difference?.other > 0 ? "-" : ""}{" "}
                {calculateddata?.difference?.other} INR
              </p>
            )}
          </Col>
        </Row>
      </div>
      <div className={styles.historicaldataDiv}>
        <span style={{ color: "red" }}>*</span>Based on historical data
      </div>
    </div>
  );

  return isMobile ? (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Compare Fees</Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderContent()}</Modal.Body>
    </Modal>
  ) : (
    <Offcanvas
      show={showModal}
      onHide={() => {
        setAmount("10000");
        setShowModal(false);
        setCurrency(defaultCurrency);
      }}
      placement="end"
      className={styles.offcanvas}
      style={{ color: "white" }}
    >
      <Offcanvas.Header closeButton className={styles.offcanvasHeader}>
        <Offcanvas.Title className={styles.offcanvasTitle}>
          Compare Fees
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{renderContent()}</Offcanvas.Body>
    </Offcanvas>
  );
}

export default SideModal;
